import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@context/AuthContext";
import "@styles/opencart-admin.css";
import "./css/LoginPage.css";

export default function LoginPage() {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from =
    location.state?.from?.pathname ||
    new URLSearchParams(location.search).get("from") ||
    "/orders";

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    const res = await auth.login(login, password);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    navigate(from, { replace: true });
  }

  return (
    <div className="login">
    <div className="oc-login-wrapper">
      <div className="oc-login-box">
        <div className="oc-login-header">
          <div className="oc-brand">
            <img
              alt="WashyWash"
              src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='28' height='28'><circle cx='14' cy='14' r='12' fill='%2323a1d1'/></svg>"
            />
            <span>WashyWash Admin</span>
          </div>
          <div className="oc-login-title">Please enter your login details.</div>
        </div>

        <form onSubmit={handleSubmit} className="oc-login-form">
          {error && <div className="oc-alert-error">{error}</div>}

          <div className="form-group">
            <label>Username / Email / Phone</label>
            <div className="oc-input-icon">
              <span className="icon">👤</span>
              <input
                type="text"
                className="oc-input"
                placeholder="Username, email or phone"
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                autoFocus
              />
            </div>
          </div>

          <div className="form-group">
            <label>Password</label>
            <div className="oc-input-icon">
              <span className="icon">🔒</span>
              <input
                type="password"
                className="oc-input"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div className="oc-login-actions">
            <button
              type="submit"
              className="oc-btn primary"
              disabled={auth.loading}
            >
              {auth.loading ? "Logging in..." : "Login"}
            </button>
          </div>
        </form>
      </div>
    </div>
    </div>
  );
}

